// A helper function for concatenating strings into a single line
// Used for removing the line breaks from template literals

export function oneLine(...args: any[]) {
    let oneLineString = '';
  
    if (args.length) {
      if (Array.isArray(args[0])) {
        const textList: string[] = args.shift();
  
        textList.forEach(text => {
          const interpolatedVar = args.shift();
          oneLineString = oneLineString.concat(text);
          oneLineString = interpolatedVar ? oneLineString.concat(interpolatedVar) : oneLineString;
        });
      } else {
        oneLineString = args.shift();
      }
    }
  
    return oneLineString.replace(/\s+/g, ' ');
  }